/** Shared chat keyframes (emotion dedupes identical keyframes by content). */
import { keyframes } from '@mui/material';

export const fadeRise = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const pulseBlink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.25; }
`;

/* ---- Octoplus v2 motion (design-v2 "Movimento"): the mascot's blink
 * (inside OpsMascotIcon) and swim, the status shimmer and the step halo. ---- */

/**
 * Working mascot "swim": a 1.5px bob with a synced, subtle squash & stretch
 * (use with `transform-origin: 50% 90%`, ~1100ms ease-in-out infinite).
 */
export const mascotSwim = keyframes`
  0%, 100% { transform: translateY(0.75px) scale(1.05, 0.95); }
  50% { transform: translateY(-0.75px) scale(0.96, 1.04); }
`;

/**
 * Status shimmer: a light band travelling across text that uses a
 * `background-clip: text` gradient (`background-size: 250% 100%`).
 */
export const statusShimmer = keyframes`
  from { background-position: 100% 0; }
  to { background-position: 0% 0; }
`;

/** Current-step halo: a ring that grows and fades around a 6px dot. */
export const haloPulse = keyframes`
  0% { transform: scale(1); opacity: 0.55; }
  70%, 100% { transform: scale(2.6); opacity: 0; }
`;
